import React from 'react'
import DownloadImg from "../assets/img/download/01.png"

function DownloadArea() {
  return (
    <div className="download-area">
        <div className="container">
            <div className="download-wrapper">
                <div className="row">
                    
                    <div className="col-lg-6">
                        <div className="download-content">
                            <div className="site-heading mb-4">
                                <span className="site-title-tagline justify-content-start">
                                    <i className="flaticon-drive"></i> Get Our App Today
                                </span>
                                <h2 className="site-title mb-10">Download <span>TaxiDo</span> - Your Ride, Simplified</h2>
                                <p>
                                    Experience hassle-free rides with TaxiDo! Whether you’re commuting to work, running errands, or exploring the city, TaxiDo is your reliable and affordable ride solution. Download the app now and enjoy seamless travel at your fingertips.
                                </p>
                            </div>
                            
                            <div className="download-btn">
                                <a href="google">
                                    <i className="pi pi-android"></i>
                                    <div className="download-btn-content">
                                        <span>Available on</span>
                                        <strong>Google Play</strong>
                                    </div>
                                </a>
                                <a href="google">
                                    <i className="pi pi-apple"></i>
                                    <div className="download-btn-content">
                                        <span>Download on</span>
                                        <strong>App Store</strong>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="download-img">
                        <img src={DownloadImg} alt="TaxiDo App Preview" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default DownloadArea